import { render, staticRenderFns } from "./AidfConsulta.vue?vue&type=template&id=305bacef&scoped=true&"
import script from "./AidfConsulta.vue?vue&type=script&lang=js&"
export * from "./AidfConsulta.vue?vue&type=script&lang=js&"
import style0 from "./AidfConsulta.vue?vue&type=style&index=0&id=305bacef&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "305bacef",
  null
  
)

export default component.exports